import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=1323202f&scoped=true"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=1323202f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323202f",
  null
  
)

export default component.exports